import { render, staticRenderFns } from "./two_lineup.vue?vue&type=template&id=33c0e167&scoped=true"
import script from "./two_lineup.vue?vue&type=script&lang=js"
export * from "./two_lineup.vue?vue&type=script&lang=js"
import style0 from "./two_lineup.vue?vue&type=style&index=0&id=33c0e167&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0e167",
  null
  
)

export default component.exports